<div class="ca-shell">
  <div class="container">
    <header class="ds-page-header">
      <div class="ds-page-header-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="10" rx="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </div>
      <div class="ds-page-header-copy">
        <h1 class="ds-page-title">Controle de Acessos</h1>
        <p class="ds-page-subtitle">Gerencie permissoes por tela, grupo e usuario</p>
      </div>
      <div class="ds-page-actions">
        <button type="button" class="btn-refresh" (click)="carregar()" [disabled]="carregando">
          Atualizar
        </button>
      </div>
    </header>

    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>
    <div *ngIf="sucesso" class="alerta alerta-ok">{{ sucesso }}</div>

    <div class="cards-resumo">
      <div class="resumo-card">
        <span>Modulos</span>
        <strong>{{ telas.length }}</strong>
      </div>
      <div class="resumo-card">
        <span>Permissoes</span>
        <strong>{{ permissoes.length }}</strong>
      </div>
      <div class="resumo-card">
        <span>Tela selecionada</span>
        <strong>{{ nomeTelaSelecionada() }}</strong>
      </div>
    </div>

    <div class="layout-grid">
      <section class="card card-telas">
        <div class="card-header">
          <div>
            <h2>Modulos do sistema</h2>
            <p>Navegue pelas pastas e selecione a tela final para aplicar permissoes</p>
          </div>
          <input type="text" [(ngModel)]="filtroTela" placeholder="Buscar tela">
        </div>

        <div *ngIf="carregando" class="estado-row">
          <app-loading-indicator></app-loading-indicator>
          Carregando...
        </div>

        <div class="table-wrap telas-table-wrap menu-tree-wrap" *ngIf="!carregando">
          <div class="menu-breadcrumb" *ngIf="caminhoTelas.length">
            <button type="button" (click)="voltarParaNivelTela(-1)">Modulos</button>
            <ng-container *ngFor="let item of caminhoTelas; let i = index">
              <span>/</span>
              <button type="button" (click)="voltarParaNivelTela(i)">{{ item.nome }}</button>
            </ng-container>
          </div>

          <button type="button" class="menu-back-row" *ngIf="caminhoTelas.length" (click)="voltarNivelTela()">
            <span class="menu-back-icon"></span>
            Voltar
          </button>

          <div *ngIf="carregandoTelas" class="estado-row">
            <app-loading-indicator></app-loading-indicator>
            Carregando itens...
          </div>

          <div class="menu-tree-list" *ngIf="!carregandoTelas">
            <div class="menu-tree-row"
                 *ngFor="let tela of telasFiltradas()"
                 [class.row-selected]="telaSelecionadaMultipla(tela)"
                 (click)="selecionarTela(tela)">

              <input *ngIf="!temFilhos(tela)"
                     type="checkbox"
                     class="menu-select-checkbox"
                     [checked]="telaSelecionadaMultipla(tela)"
                     (click)="$event.stopPropagation()"
                     (change)="alternarTelaSelecionada(tela, $event)">

              <span *ngIf="temFilhos(tela)" class="menu-select-placeholder"></span>

              <span class="tela-icon" [ngClass]="classeIconeTela(tela)">
                <img *ngIf="tela.nivel === 0 && tela.iconURL" [src]="tela.iconURL" [alt]="tela.nome">
              </span>

              <span class="tela-texto">
                <strong>{{ tela.nome }}</strong>
                <span *ngIf="tela.rota && !temFilhos(tela)">{{ tela.rota }}</span>
              </span>

              <span class="menu-arrow" *ngIf="temFilhos(tela)"></span>
            </div>

            <div *ngIf="telasFiltradas().length === 0" class="empty-cell menu-empty">
              Nenhum item encontrado.
            </div>
          </div>
        </div>
      </section>

      <section class="card card-permissoes-existentes">
        <div class="card-header permissoes-header">
          <div>
            <h2>Permissoes existentes</h2>
          </div>
        </div>

        <div class="permissoes-filtros">
          <input type="text" [(ngModel)]="filtroPermissao" placeholder="Buscar permissao">
          <select [(ngModel)]="form.tipoAlvo" (ngModelChange)="aoAlterarTipoAlvo()">
            <option value="GRUPO">Grupo</option>
            <option value="USUARIO">Usuario</option>
          </select>
        </div>

        <div class="acesso-lista-wrap acesso-lista-lateral">
          <div *ngIf="carregandoPermissoes" class="estado-row">
            <app-loading-indicator></app-loading-indicator>
            Carregando permissoes...
          </div>

          <div class="acesso-lista" *ngIf="!carregandoPermissoes && permissoesFiltradas().length">
            <button type="button"
                    class="acesso-card"
                    *ngFor="let p of permissoesFiltradas()"
                    [title]="'Editar acesso de ' + (p.nomeAlvo || '-')"
                    (click)="editarPermissaoExistente(p)">
              <div class="acesso-avatar">
                <img [src]="fotoPermissao(p)" [alt]="p.nomeAlvo" (error)="p._fotoErro = true">
                <span>{{ iniciaisPermissao(p) }}</span>
              </div>
              <div class="acesso-info">
                <strong>{{ p.nomeAlvo || '-' }}</strong>
                <span>{{ p.agrupamento || p.tipoAlvo }}</span>
              </div>
            </button>
          </div>

          <div *ngIf="!carregandoPermissoes && permissoesFiltradas().length === 0" class="empty-cell acesso-empty">
            {{ telaSelecionada ? 'Nenhuma permissao encontrada para esta tela.' : 'Selecione uma tela para visualizar permissoes.' }}
          </div>
        </div>

        <div class="card-action-footer">
          <button type="button"
                  class="btn-primary btn-salvar-acesso"
                  (click)="abrirModalNovoAcesso()">
            Novo Acesso
          </button>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="modalNovoAcessoAberto">
    <div class="modal-card modal-novo-acesso">
      <div class="modal-header">
        <div>
          <h2>{{ edicaoAcesso ? 'Editar acesso' : 'Novo acesso' }}</h2>
          <p>{{ edicaoAcesso ? 'Altere as permissoes do acesso selecionado' : 'Vincule a tela selecionada a um grupo ou usuario' }}</p>
        </div>

        <button type="button"
                class="modal-close"
                (click)="fecharModalNovoAcesso()">
          x
        </button>
      </div>

      <div class="modal-body novo-acesso-body">
        <div class="form-grid">
          <label>
            Tela
            <input type="text" [value]="nomeTelaSelecionada()" readonly>
          </label>

          <label>
            Tipo
            <select [(ngModel)]="form.tipoAlvo" (ngModelChange)="aoAlterarTipoAlvo()" [disabled]="edicaoAcesso">
              <option value="GRUPO">Grupo</option>
              <option value="USUARIO">Usuario</option>
            </select>
          </label>

          <div class="alvo-identificacao-row">
            <label>
              Codigo
              <input type="text"
                     class="codigo-alvo-input"
                     [(ngModel)]="form.codigoAlvo"
                     placeholder="Codigo"
                     tabindex="-1"
                     readonly>
            </label>

            <label class="campo-alvo-nome">
              Nome do {{ alvoLabelSingular() }}
              <div class="input-com-lupa"
                   [class.input-com-lupa-desabilitado]="edicaoAcesso"
                   (click)="abrirModalUsuarios()">
                <button type="button"
                        class="btn-lupa-input"
                        [title]="'Buscar ' + alvoLabelSingular()"
                        [disabled]="edicaoAcesso"
                        (click)="$event.preventDefault(); $event.stopPropagation(); abrirModalUsuarios()">
                  <span aria-hidden="true">Buscar</span>
                </button>

                <input type="text"
                       [(ngModel)]="form.nomeAlvo"
                       [placeholder]="'Nome do ' + alvoLabelSingular()"
                       readonly>
              </div>
            </label>
          </div>
        </div>

        <div class="novo-acesso-split">
          <div class="novo-acesso-usuarios">
            <!-- Campo movido para a linha de identificacao acima.
            <label class="campo-alvo-nome">
              <div class="input-com-lupa">
                <button type="button"
                        class="btn-lupa-input"
                        [title]="'Buscar ' + alvoLabelSingular()"
                        [disabled]="edicaoAcesso"
                        (click)="$event.preventDefault(); $event.stopPropagation(); abrirModalUsuarios()">
                  🔍
                </button>

                <input type="text"
                       [(ngModel)]="form.nomeAlvo"
                       [placeholder]="'Nome do ' + alvoLabelSingular()"
                       readonly>
              </div>
            </label>
            -->

            <div class="usuarios-selecionados-box">
              <div class="usuarios-selecionados-titulo">
                {{ alvoLabelPluralTitulo() }} adicionados
              </div>

              <div class="usuarios-selecionados-lista" *ngIf="usuariosSelecionados.length > 0">
                <div class="usuario-selecionado-mini"
                     *ngFor="let usuario of usuariosSelecionados">
                  <div class="usuario-selecionado-info">
                    <strong>{{ usuario.descricao }}</strong>
                    <span>{{ usuario.agrupamento || (tipoAlvoEhUsuario() ? 'Sem grupo' : 'Grupo') }}</span>
                  </div>

                  <button type="button"
                          class="usuario-selecionado-remove"
                          [title]="edicaoAcesso ? 'Excluir permissao' : 'Remover ' + alvoLabelSingular()"
                          (click)="abrirConfirmarExcluirPermissao(usuario)">
                    x
                  </button>
                </div>
              </div>

              <div class="usuarios-selecionados-empty" *ngIf="usuariosSelecionados.length === 0">
                Nenhum {{ alvoLabelSingular() }} adicionado.
              </div>
            </div>
          </div>

          <div class="novo-acesso-permissoes">
            <div class="permissoes-box permissoes-dinamicas-box"
                 [class.permissoes-vazia]="acessosDisponiveis.length === 0">

              <ng-container *ngIf="acessosDisponiveis.length > 0; else nenhumaPermissaoSelecionadaModal">
                <div class="permissoes-dinamicas-titulo">
                  Aplicar os seguintes acessos
                </div>

                <div class="permissoes-dinamicas-header">
                  <span>Permitido</span>
                  <span>Usar Grupo</span>
                  <span>Repassar</span>
                  <span></span>
                </div>

                <div class="permissoes-dinamicas-row"
                     *ngFor="let acesso of acessosDisponiveis">

                  <label class="check-cell">
                    <input type="checkbox"
                           [(ngModel)]="acesso.permissao">
                  </label>

                  <label class="check-cell">
                    <input type="checkbox"
                           [(ngModel)]="acesso.grupo">
                  </label>

                  <label class="check-cell">
                    <input type="checkbox"
                           [(ngModel)]="acesso.repassar">
                  </label>

                  <span class="permissao-descricao">
              {{ acesso.descricao }}
            </span>
                </div>
              </ng-container>

              <ng-template #nenhumaPermissaoSelecionadaModal>
                <div class="permissoes-empty-state">
                  Selecione uma tela para carregar as permissoes disponiveis.
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn-secundario"
                (click)="fecharModalNovoAcesso()">
          Cancelar
        </button>

        <button *ngIf="acessosDisponiveis.length > 0"
                type="button"
                class="btn-primary btn-salvar-acesso"
                (click)="salvarPermissao()"
                [disabled]="salvando"><app-loading-indicator *ngIf="salvando" size="inline"></app-loading-indicator>
          {{ salvando ? 'Salvando...' : 'Salvar acesso' }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="modalUsuariosAberto">
    <div class="modal-card modal-usuarios">

      <div class="modal-header">
        <div>
          <h2>Selecionar {{ alvoLabelSingular() }}</h2>
          <p>Busque e selecione o {{ alvoLabelSingular() }} que recebera as permissoes</p>
        </div>

        <button type="button"
                class="modal-close"
                (click)="fecharModalUsuarios()">
          x
        </button>
      </div>

      <div class="modal-search">
        <input type="text"
               [(ngModel)]="filtroUsuarioModal"
               (input)="filtrarUsuariosModal()"
               [placeholder]="'Buscar ' + alvoLabelSingular() + ' por codigo, nome ou grupo'">
      </div>

      <div *ngIf="carregandoUsuariosModal" class="estado-row">
        <app-loading-indicator></app-loading-indicator>
        Carregando {{ alvoLabelPlural() }}...
      </div>

      <div class="usuarios-modal-lista" *ngIf="!carregandoUsuariosModal">

        <button type="button"
                class="usuario-modal-row"
                *ngFor="let usuario of usuariosModalFiltrados"
                (click)="selecionarUsuarioModal(usuario)">

          <div class="usuario-modal-avatar">
            <img [src]="fotoUsuarioModal(usuario)"
                 [alt]="usuario.descricao"
                 (error)="usuario._fotoErro = true">

            <span>{{ iniciaisUsuarioModal(usuario) }}</span>
          </div>

          <div class="usuario-modal-info">
            <strong>{{ usuario.descricao }}</strong>
            <span>{{ usuario.agrupamento || (tipoAlvoEhUsuario() ? 'Sem grupo' : 'Grupo') }}</span>
          </div>

          <span class="usuario-modal-codigo">
            {{ usuario.id }}
          </span>
        </button>

        <div class="empty-cell acesso-empty" *ngIf="usuariosModalFiltrados.length === 0">
          Nenhum {{ alvoLabelSingular() }} encontrado.
        </div>

      </div>
    </div>
  </div>
  <div class="modal-backdrop modal-backdrop-confirmacao" *ngIf="modalConfirmarExclusaoAberto">
    <div class="modal-card modal-aviso">

      <div class="modal-aviso-header">
        <h2>Confirmar exclusao</h2>
      </div>

      <div class="modal-aviso-body">
        Deseja realmente excluir essa permissao?
      </div>

      <div class="modal-aviso-footer modal-confirmacao-footer">
        <button type="button"
                class="btn-secundario"
                (click)="cancelarExcluirPermissao()"
                [disabled]="salvando">
          Cancelar
        </button>

        <button type="button"
                class="btn-primary btn-salvar-acesso btn-excluir-permissao"
                (click)="confirmarExcluirPermissao()"
                [disabled]="salvando">
          {{ salvando ? 'Excluindo...' : 'Confirmar' }}
        </button>
      </div>

    </div>
  </div>
  <div class="modal-backdrop" *ngIf="modalAvisoAberto">
    <div class="modal-card modal-aviso">

      <div class="modal-aviso-header">
        <h2>{{ modalAvisoTitulo }}</h2>
      </div>

      <div class="modal-aviso-body">
        {{ modalAvisoMensagem }}
      </div>

      <div class="modal-aviso-footer">
        <button type="button"
                class="btn-primary btn-salvar-acesso"
                (click)="fecharModalAviso()">
          OK
        </button>
      </div>

    </div>
  </div>
</div>
